import { TRoute } from './types';

export const routes: TRoute[] = [
  {
    id: 'start_over',
    title: 'Start over',
    to: '/payments/payment-methods',
    icon: 'House',
  },
  {
    id: 'contact_us',
    title: 'Contact us',
    to: 'https://www.clientpaydirect.com/contact-us',
    icon: 'Layers',
    target: '_blank',
    secondIcon: 'ArrowUpRight',
  },
];
